import { iconSizes } from '@mds/tokens';
import type { Theme as BaseTheme, CSSObject, CssVarsTheme, PaletteColor, TypographyStyle } from '@mui/material';
import type { CSSProperties as ReactCSSProperties } from 'react';
import { inputClearIconSizeReduction } from '../../consts/theme';
import { lightPalette } from '../palette';
import type {} from '../types';

export const paletteColorNames = (Object.entries(lightPalette) as [string, PaletteColor][])
  .filter(([, palette]) => palette && palette.main && palette.strong && palette.contrastText)
  .map(([key]) => key as 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success');

export type Theme = Omit<BaseTheme, 'applyStyles'> & CssVarsTheme;

export const inputAdornmentIconSizes = {
  medium: iconSizes.md,
  small: iconSizes.sm,
} as const;
export const inputAdornmentIconButtonSizes = {
  medium: inputAdornmentIconSizes.medium + 8,
  small: inputAdornmentIconSizes.small + 8,
} as const;
type InputAdornmentSize = keyof typeof inputAdornmentIconButtonSizes;

export const inputAdornmentIconButtonStyles = (size: InputAdornmentSize) => ({
  boxSizing: 'border-box' as const,
  height: inputAdornmentIconButtonSizes[size],
  minHeight: inputAdornmentIconButtonSizes[size],
  minWidth: inputAdornmentIconButtonSizes[size],
  width: inputAdornmentIconButtonSizes[size],
});

export const inputAdornmentIconButtonVariables = (size: InputAdornmentSize) => ({
  '--mds-icon-button-box-sizing': 'border-box',
  '--mds-icon-button-height': `${inputAdornmentIconButtonSizes[size]}px`,
  '--mds-icon-button-min-height': `${inputAdornmentIconButtonSizes[size]}px`,
  '--mds-icon-button-min-width': `${inputAdornmentIconButtonSizes[size]}px`,
  '--mds-icon-button-width': `${inputAdornmentIconButtonSizes[size]}px`,
});
export const inputClearIconSizes = {
  medium: inputAdornmentIconSizes.medium - inputClearIconSizeReduction,
  small: inputAdornmentIconSizes.small - inputClearIconSizeReduction,
} as const;
export const selectIconSizes = {
  medium: iconSizes.md,
  small: iconSizes.sm,
} as const;

type TypographyCssProperties = Pick<
  TypographyStyle | ReactCSSProperties,
  'fontFamily' | 'fontSize' | 'fontStyle' | 'fontWeight' | 'letterSpacing' | 'lineHeight' | 'textTransform'
>;

export const typographyStyles = (styles: TypographyCssProperties): CSSObject => ({
  fontFamily: styles.fontFamily,
  fontSize: styles.fontSize,
  fontStyle: styles.fontStyle,
  fontWeight: styles.fontWeight,
  letterSpacing: styles.letterSpacing,
  lineHeight: styles.lineHeight,
  textTransform: styles.textTransform,
});
